import { Directive } from '@angular/core';

@Directive({
    selector: '[appSearchInputOptionTemplate]',
    standalone: false
})
export class SearchInputOptionTemplateDirective {

  constructor() { }

}
